/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Collection template.
 *
 * @namespace collection
 */

import { register } from '@shopify/theme-sections';

import ProductCard from '../components/product-card';
import initPagination from '../components/pagination';

register('collection-template', {
  onLoad() {
    const productCards = this.container.querySelectorAll('.product-card');
    if (productCards.length > 0) {
      productCards.forEach((product) => ProductCard(product));
    }

    // Initialise pagination
    initPagination(this.id);
  },
});
